import { IconName } from '@optimus-web/icons';
import { InputValue, Labeled, RenderDropdownIconProps, Selected, SizeType } from '../types';

export interface SelectDefaultedProps {
    name?: string;
    selected: Selected | undefined;
    multiselect?: boolean;
    virtualized?: boolean;
    defaultItemHeight?: number;
    overlayMaxHeight?: number;
    size?: SizeType;
    sizeToAnchor?: boolean;
    compact?: boolean;
    valueMapper?: (c: React.ReactElement) => InputValue;
    searchValueMapper?: <T extends Labeled>(c: React.ReactElement<T>) => string;
    displayMapper?: <T extends Labeled>(c: React.ReactElement<T>) => React.ReactNode;
    emptyMessage?: React.ReactNode;
    renderDropdownIcon?: (o: RenderDropdownIconProps) => React.ReactNode;
    onFocus?: () => void;
    onBlur?: () => void;
    onChange?: (e: React.ChangeEvent, s: Selected) => void;
    onClear?: () => void;
    shadowField?: boolean;
    large?: boolean;
    portalContainerId?: string;
    disabled?: boolean;
    placeholder?: React.ReactNode;
    autocomplete?: boolean;
    children: React.ReactNode;
    iconName?: IconName;
    leadingImage?: string;
    trailingImage?: string;
    suffix?: React.ReactNode;
    loader?: boolean;
    inputType?: React.HTMLInputTypeAttribute;
    inputValuePattern?: RegExp;
}
